import React, { useEffect, useState, useRef } from 'react';

interface LoadingScreenProps {
  onLoadComplete: () => void;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ onLoadComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  
  const containerRef = useRef<HTMLDivElement>(null);
  
  // Simulate loading progress
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        const increment = 1 + Math.floor((100 - prev) / 20);
        const newProgress = Math.min(prev + increment, 100);
        
        if (newProgress === 100) {
          clearInterval(interval);
          
          // Mark as complete
          setIsComplete(true);
          
          // Add a small delay before calling onLoadComplete for visual polish
          setTimeout(() => {
            onLoadComplete();
          }, 800);
        }
        
        return newProgress;
      });
    }, 50);
    
    return () => clearInterval(interval);
  }, [onLoadComplete]);
  
  return (
    <div 
      ref={containerRef}
      className="fixed inset-0 bg-gray-950 bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 flex flex-col items-center justify-center z-[100] w-full h-full"
      style={{ position: 'fixed', left: 0, top: 0, right: 0, bottom: 0 }}
    >
      <div className={`flex flex-col items-center transition-opacity duration-500 ${isComplete ? 'opacity-0' : 'opacity-100'}`}>
        {/* Logo */}
        <div className="mb-8 relative">
          <img 
            src="/images/logo.png" 
            alt="Recoil.club Logo" 
            className="w-64 h-auto relative"
          />
        </div>
        
        {/* Progress bar */}
        <div className="w-64 h-0.5 bg-gray-800 relative overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full bg-gradient-to-r from-blue-500 to-blue-400 transition-all duration-200 ease-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 